import { detectLighthouseSheet } from 'features/RateCodes/lighthouseFormat'
import { detectNativeSheet } from 'features/RateCodes/nativeFormat'

export const importFormats = {
  native: 'native',
  lighthouse: 'lighthouse',
  unknown: 'unknown'
}

export const importFormatNames = {
  [importFormats.native]: 'Directful rate codes export',
  [importFormats.lighthouse]: 'Lighthouse market segment mapping',
  [importFormats.unknown]: 'unrecognized'
}

/**
 * The fingerprints we try, in order. Lighthouse is the first non native format and more are
 * expected, so a new one is added here with its own detect function rather than by editing the
 * import flow. Order is not significant today because the two header sets do not overlap; the
 * cheaper native check runs first.
 */
export const importFormatFingerprints = [
  { format: importFormats.native, detect: detectNativeSheet },
  { format: importFormats.lighthouse, detect: detectLighthouseSheet }
]

/**
 * Decides what an uploaded workbook is before any of it is processed.
 * Returns the detection the matching format needs to read the sheet, or the unknown format when
 * no fingerprint matches, which the import window reports back to the CSM.
 */
export function detectWorkbookFormat(workbook) {
  for (const fingerprint of importFormatFingerprints) {
    const detection = fingerprint.detect(workbook)

    if (detection) {
      return { format: fingerprint.format, detection }
    }
  }

  return { format: importFormats.unknown, detection: null }
}
